export default function initConditionalLink() {
  const linkOndeAportar = document.querySelector("[js-modal-menu]");
  const linkDefinirObjetivo = document.querySelector("[js-conditional-link]");
  const modal_menu = ModalX(".modal_menu", {
    deep: true,
    zIndex: 1000000,
    zIndexDeep: 900000
  });

  function redirectToURL (evt, route){
    evt.preventDefault();
    window.location.href = `${
      window.location.origin
    }/${route}`;
  }



  function conditionalLinks() {
    if (!GLOBAL.checkIfExistsValueOnLocalStorage("estadoAtual")) {
			console.log('entrou')
      linkOndeAportar && linkOndeAportar.addEventListener("click", (e)=> redirectToURL(e, 'adicionar-manualmente'));
      linkDefinirObjetivo && linkDefinirObjetivo.addEventListener("click", (e)=> redirectToURL(e, 'definicao-objetivo'));
    } else {
      linkDefinirObjetivo && linkDefinirObjetivo.addEventListener("click", (e)=> redirectToURL(e, 'adicionar-objetivo'));
      modal_menu.init();
    }
  }


  // window.addEventListener("click", ({target}) => {
  //   if (!target.hasAttribute("js-modal-menu") || !target.hasAttribute("js-conditional-link")) 
  //     return;
  //   conditionalLinks();
  // });

  // conditionalLinks();
}
